export const allData = [
    {
        "trainNumber": "12215",
        "trainName": "BDTS GARIB RATH",
        "trainRunsOn": "S",
        "trainType": " Garib Rath ",
        "trainSourceRunningStatus": {
            "trainSource": "DEE",
            "trainSourceTime": "08:55",
            "trainSourceDate": "Sat, 9 Dec"
        },
        "journeyDuration": "",
        "trainDestinationRunningStatus": {
            "trainDestination": "ADI",
            "trainDestinationTime": "00:35",
            "trainDestinationDate": "Sun, 10 Dec"
        },
        "trainClassandPrice": [
            {
                "class": "3A",
                "price": "920",
                "status": " WL 102",
                "cnfProbability": "60%"
            }
        ]
    },
    {
        "trainNumber": "12918",
        "trainName": "GUJRAT S KRANTI",
        "trainRunsOn": "S",
        "trainType": " Mail/Express ",
        "trainSourceRunningStatus": {
            "trainSource": "NZM",
            "trainSourceTime": "13:25",
            "trainSourceDate": "Sat, 9 Dec"
        },
        "journeyDuration": "",
        "trainDestinationRunningStatus": {
            "trainDestination": "ADI",
            "trainDestinationTime": "03:25",
            "trainDestinationDate": "Sun, 10 Dec"
        },
        "trainClassandPrice": [
            {
                "class": "SL",
                "price": "535",
                "status": " WL 83",
                "cnfProbability": "48%"
            },
            {
                "class": "3A",
                "price": "1400",
                "status": " WL 45",
                "cnfProbability": "55%"
            },
            {
                "class": "2A",
                "price": "1990",
                "status": " WL 12",
                "cnfProbability": "56%"
            },
            {
                "class": "1A",
                "price": "3365",
                "status": " WL 2",
                "cnfProbability": "51%"
            }
        ]
    },
    {
        "trainNumber": "12916",
        "trainName": "ASHRAM EXPRESS",
        "trainRunsOn": "S",
        "trainType": " Mail/Express ",
        "trainSourceRunningStatus": {
            "trainSource": "DLI",
            "trainSourceTime": "15:20",
            "trainSourceDate": "Sat, 9 Dec"
        },
        "journeyDuration": "",
        "trainDestinationRunningStatus": {
            "trainDestination": "ADI",
            "trainDestinationTime": "06:20",
            "trainDestinationDate": "Sun, 10 Dec"
        },
        "trainClassandPrice": [
            {
                "class": "SL",
                "price": "490",
                "status": " WL 76",
                "cnfProbability": "68%"
            },
            {
                "class": "3E",
                "price": "1200",
                "status": " WL 26",
                "cnfProbability": "80%"
            },
            {
                "class": "3A",
                "price": "1295",
                "status": " WL 44",
                "cnfProbability": "76%"
            },
            {
                "class": "2A",
                "price": "1835",
                "status": " WL 24",
                "cnfProbability": "80%"
            },
            {
                "class": "1A",
                "price": "3095",
                "status": " WL 10",
                "cnfProbability": "86%"
            }
        ]
    },
    {
        "trainNumber": "12958",
        "trainName": "ADI SJ RAJDHANI",
        "trainRunsOn": "S",
        "trainType": " Rajdhani ",
        "trainSourceRunningStatus": {
            "trainSource": "NDLS",
            "trainSourceTime": "19:55",
            "trainSourceDate": "Sat, 9 Dec"
        },
        "journeyDuration": "",
        "trainDestinationRunningStatus": {
            "trainDestination": "ADI",
            "trainDestinationTime": "08:25",
            "trainDestinationDate": "Sun, 10 Dec"
        },
        "trainClassandPrice": [
            {
                "class": "3A",
                "price": "2336",
                "status": " WL 57",
                "cnfProbability": "74%"
            },
            {
                "class": "2A",
                "price": "3173",
                "status": " WL 17",
                "cnfProbability": "81%"
            },
            {
                "class": "1A",
                "price": "3935",
                "status": " WL 8",
                "cnfProbability": "85%"
            }
        ]
    },
    {
        "trainNumber": "19032",
        "trainName": "YOGA EXPRESS",
        "trainRunsOn": "S",
        "trainType": " Mail/Express ",
        "trainSourceRunningStatus": {
            "trainSource": "DSA",
            "trainSourceTime": "21:28",
            "trainSourceDate": "Sat, 9 Dec"
        },
        "journeyDuration": "",
        "trainDestinationRunningStatus": {
            "trainDestination": "ADI",
            "trainDestinationTime": "15:35",
            "trainDestinationDate": "Sun, 10 Dec"
        },
        "trainClassandPrice": [
            {
                "class": "SL",
                "price": "475",
                "status": " WL 149",
                "cnfProbability": "48%"
            },
            {
                "class": "3A",
                "price": "1275",
                "status": " WL 69",
                "cnfProbability": "57%"
            },
            {
                "class": "2A",
                "price": "1825",
                "status": " WL 36",
                "cnfProbability": "64%"
            },
            {
                "class": "1A",
                "price": "3080",
                "status": " WL 4",
                "cnfProbability": "83%"
            }
        ]
    }
]

export const singleTrain = [

    {
        "trainNumber": "12215",
        "trainName": "BDTS GARIB RATH",
        "trainRunsOn": "S",
        "trainType": " Garib Rath ",
        "trainSourceRunningStatus": {
            "trainSource": "DEE",
            "trainSourceTime": "08:55",
            "trainSourceDate": "Sat, 9 Dec"
        },
        "journeyDuration": "",
        "trainDestinationRunningStatus": {
            "trainDestination": "ADI",
            "trainDestinationTime": "00:35",
            "trainDestinationDate": "Sun, 10 Dec"
        },
        "trainClassandPrice": [
            {
                "class": "3A",
                "price": "920",
                "status": " WL 102",
                "cnfProbability": "60%"
            }
        ]
    }
]